import axios from "axios";

const paymentService = {

    crearPago: async (formData: FormData) => {
        try {           
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Payments/crearPago`,
                formData
            );
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    crearPlanPago: async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Payments/crearPlanPago`, null);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    confirmarPago: async (pago: any) => {
        try {            
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Payments/confirmarPago`,
                pago
            );
            return response.data;

        } catch (error: any) {            
            throw error.response ? error.response.data : error.message;
        }
    },

    getDeudaActual: async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/getDeudaActual`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getDetalleDeDeuda: async () => {
        try {           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/getDetalleDeudaActual`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getUltimosPagos: async () => {
        try {           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/getUltimosPagos`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    existenPagosPendientesImputacion: async () => {
        try {            
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/existenPagosPendientesImputacion`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getConceptosBoleta: async () => {
        try {           
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/getConceptosBoleta`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },

    getConceptoPlan: async () => {
        try {            
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Payments/getConceptoPlan`);
            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
};

export default paymentService
